module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_troms_og_finnmark_pos.baf086cb.png";